import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-pin-map",
  "use": "icon-si-glyph-pin-map-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-pin-map\" id=\"icon-si-glyph-pin-map\"><title>983</title><defs></defs><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(6.000000, 0.000000)\" fill=\"#434343\"><path d=\"M5.953,8.979 L0.025,8.979 L0.025,7.668 L1,6.991 L1,4.926 L0.025,4.122 L0.025,2.021 L5.953,2.021 L5.953,4.249 L4.979,4.926 L4.979,6.991 L5.954,7.625 L5.953,8.979 Z\" class=\"si-glyph-fill\" /><path d=\"M3.986,7.993 L2.038,7.993 L2.038,10.607 L3.027,15.979 L3.986,10.607 L3.986,7.993 Z\" class=\"si-glyph-fill\" /><rect x=\"0\" y=\"0\" width=\"5.959\" height=\"0.942\" class=\"si-glyph-fill\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-pin-map.svg
// module id = QZly
// module chunks = 62